import {
  AccessTimeRounded,
  ArrowBack,
  CalendarTodayRounded,
  CheckCircleRounded,
  CloseRounded,
  EditRounded,
  GroupsRounded,
  ListAltRounded,
  // NotesRounded,
  OndemandVideoRounded,
  PinDropRounded,
  RefreshOutlined,
  RefreshRounded,
  SpellcheckRounded,
  UploadRounded,
} from '@mui/icons-material';
import {
  Avatar,
  AvatarGroup,
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Step,
  StepLabel,
  Stepper,
  SwipeableDrawer,
  TextField,
  Tooltip,
  Typography,
} from '@mui/material';

import { toast } from 'react-toastify';
import { useForm } from 'react-hook-form';
import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import dayjs from 'dayjs';
import _ from 'lodash';

import { GuestToSelect, GuestToSelectNote } from '..';

import {
  activeMeetingRequest,
  BoardMember,
  cancelMeetingRequest,
  getMeetingByIdRequest,
  getThemesByMeetingIdRequest,
  getUsersByCompanyIdRequest,
  Guest,
  Meeting,
  sendMeetingInviteRequest,
  sendNotificationThemesRequest,
  Theme,
  updateMeetingRequest,
  User,
} from '../../../services';
import {
  createNoteRequest,
  Note,
  deleteNoteRequest,
  updateNoteRequest,
  getNotesByUserIdAndMeetingIdRequest,
} from '../../../services/requests/anotacoes';

import { convertStringToDateToSave } from '../../../utils/dateHelpers';
import { stringAvatar } from '../../../utils/avatarGenerator';

import {
  Container,
  Div,
  Header,
  Page,
  SectionHeaderDrawer,
  SectionMeeting,
  TitleMembers,
  BoxText,
  RecurrenceButton,
  Users,
  ContainerUsers,
  ColorLibConnector,
} from './styles';

import { Agenda } from '../CriarReuniao/Agenda';
import { StepMembros } from '../StepMembros';
import { RecurrenceList } from './RecurrenceList';
import { EditarReuniao } from './EditarReuniao';

import { ConfirmModal } from '../../../components/ConfirmModal';
import { MeetingMinutes } from '../components/MeetingMinutes';
import { ColorlibStepIcon } from '../components/IconStepper';
import { ModalCloseThemes } from '../components/ModalCloseThemes';

import useCompanyStore from '../../../store/companies';
import useAuthStore from '../../../store/auth';
import useMeetingStore from '../../../store/meetings';
import useMinuteStore from '../../../store/minute';
import { ModalSuccessInvite } from '../components/ModalSuccessInvite';
import { LoadingBackdrop } from '../../../components/LoadingBackdrop';

const stepsLabel = [
  { name: 'Reunião criada', component: CalendarTodayRounded },
  {
    disableNameForThemes: 'Defina as pautas',
    activeNameForThemes: 'Pautas definidas',
    component: ListAltRounded,
  },
  {
    name: 'Reunião realizada',
    component: CheckCircleRounded,
  },
  {
    disableNameForMinute: 'Insira a ata',
    activeNameForMinute: 'Ata inserida',
    component: UploadRounded,
  },
  {
    disableNameToSign: 'Assine a ata',
    activeNameToSign: 'Ata assinada',
    component: SpellcheckRounded,
  },
];

export const DetalhesReuniao = () => {
  const navigate = useNavigate();
  const params = useParams();

  const setMinute = useMinuteStore(state => state.setMinute);
  const minute = useMinuteStore(state => state.minute);
  const user = useAuthStore(state => state.user);
  const selectedCompany = useCompanyStore(state => state.selectedCompany);
  const setSelectedMeetingStore = useMeetingStore(
    state => state.setSelectedMeetings,
  );
  // const [openModalDuplicar, setOpenModalDuplicar] = useState(false);
  const [openDrawerEditMeeting, setOpenDrawerEditMeeting] = useState(false);
  const [openDrawerEditMembers, setOpenDrawerEditMembers] = useState(false);
  const [meetingSelect, setMeetingSelect] = useState<Meeting>({} as Meeting);
  const [filesToVerify, setFilesToVerify] = useState();
  const [openModalThemes, setOpenModalThemes] = useState(false);
  const [openModalReOpenThemes, setOpenModalReOpenThemes] = useState(false);
  const [openModalFinishedMeeting, setOpenModalFinishedMeeting] =
    useState(false);
  const [listagemTemas, setListagemTemas] = useState<Theme[]>([]);
  const [listaUsuariosTheme, setListaUsuariosTheme] = useState<User[]>([]);
  const [listaConvidados, setListaConvidados] = useState<Guest[]>([]);
  const [listaConvidadosNotes, setListaConvidadosNotes] = useState<Guest[]>([]);
  const [valueNote, setValueNote] = useState<string>();
  const [newMeetingId, setNewMeetingId] = useState('');
  const [listaUsuarios, setListaUsuarios] = useState<
    GuestToSelect[] | undefined
  >([]);
  const [dialogCancelOpen, setDialogCancelOpen] = useState(false);
  const [dialogActiveOpen, setDialogActiveOpen] = useState(false);
  const [openDrawerRecurrence, setOpenDrawerRecurrence] = useState(false);
  const [recurrenceTotal, setRecurrenceTotal] = useState(0);
  const [recurrencePosition, setRecurrencePosition] = useState(0);
  const listagemRepresentantePauta = meetingSelect?.guests?.map(u => u.name);
  const [openDrawerAnotacao, setOpenDrawerAnotacao] = useState(false);
  const [nota, setNota] = useState<Note>({} as Note);
  const [listaUsersNote, setListaUserNote] = useState<GuestToSelectNote[]>([]);
  const [openModalDeleteNote, setOpenModalDeleteNote] = useState(false);
  const userFiltered = meetingSelect?.guests?.find(u => u?.id === user?.id);
  const [loadingNotes, setLoadingNotes] = useState(true);
  const [loadingRequest, setLoadingRequest] = useState(false);
  const [loadingMeeting, setLoadingMeeting] = useState(true);
  const [loadingCancel, setLoadingCancel] = useState(false);
  const [loadingSendInvite, setLoadingSendInvite] = useState(false);
  const [activeStep, setActiveStep] = useState(0);
  const [skipped, setSkipped] = useState(new Set<number>());
  const [themesFinish, setThemesFinish] = useState(false);
  const [meetingFinish, setMeetingFinish] = useState(false);
  const [dateToFinishedMeeting, setDateToFinishedMeeting] = useState('');
  const [dateToFinishedThemes, setDateToFinishedThemes] = useState<any>('');
  // const [dateToAddMinute, setDateToAddMinute] = useState('');
  // const [dateToSignedMinute, setDateToSignedMinute] = useState('');
  const [searchForUsers, setSearchForUsers] = useState('');
  const [checked, setChecked] = useState(false);
  const [openModalToCreateInvite, setOpenModalToCreateInvite] = useState(false);
  const [openModalSuccessInvite, setOpenModalSuccessInvite] = useState(false);
  const [selectedAll, setSelectedAll] = useState<boolean | null>(null);
  const [linkZoomRemoved, setLinkZoomRemoved] = useState<boolean>(false);
  const [authorizationCode, setAuthorizationCode] = useState<string | null>(
    null,
  );
  const [zoomActived, setZoomActived] = useState(false);
  const [loadingZoom, setLoadingZoom] = useState(false);
  const [hasJitsi, setHasJitsi] = useState(false);
  const [jitsiActived, setJitsiActived] = useState(false);
  const [linkJitsiRemoved, setLinkJitsiRemoved] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const listMeetingMembers = meetingSelect?.guests?.filter(
    m => m?.profile === 'GS2',
  );
  const listaUsuariosNotes = listaConvidados.map(u => ({
    name: u.name,
    id: u.id,
    email: u.email,
    avatar_url: u.avatar_url,
  }));

  const date = dayjs(new Date()).format('DD/MM/YYYY');

  const isStepSkipped = useCallback(
    (step: number) => {
      return skipped.has(step);
    },
    [skipped],
  );

  const handleNext = useCallback(() => {
    let newSkipped = skipped;
    if (isStepSkipped(activeStep)) {
      newSkipped = new Set(newSkipped.values());
      newSkipped.delete(activeStep);
    }

    setActiveStep(prevActiveStep => prevActiveStep + 1);
    setSkipped(newSkipped);
  }, [activeStep, isStepSkipped, skipped]);

  const handleGoback = useCallback(() => {
    let newSkipped = skipped;
    if (isStepSkipped(activeStep)) {
      newSkipped = new Set(newSkipped.values());
      newSkipped.delete(activeStep);
    }

    setActiveStep(prevActiveStep => prevActiveStep - 1);
    setSkipped(newSkipped);
  }, [activeStep, isStepSkipped, skipped]);

  const handleChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      setChecked(event.target.checked);
    },
    [],
  );

  useEffect(() => {
    if (!meetingSelect?.file_id) {
      setMinute({
        fileId: '',
        name: '',
        signatures: [],
        signed: false,
        status: '',
      });
    }
  }, [meetingSelect]);

  const formValidation = useCallback((): any => {
    return Yup.object().shape({
      title: Yup.string().required('O título é obrigatório.'),
      start_at: Yup.string().required('A data inicial é obrigatória.'),
      duration: Yup.number()
        .min(1, 'A duração não pode ser menor que 1')
        .required('A duração é obrigatória.'),
      link_address: Yup.string()
        .nullable()
        .url('Digite um link de reunião válido'),
      local_address: Yup.string().nullable(),
      titleNote: Yup.string().nullable(),
      description: Yup.string()
        .nullable()
        .max(500, 'Não é permitido ultrapassar 500 carácteres'),
    });
  }, []);

  const { setValue } = useForm({
    resolver: yupResolver(formValidation()),
  });

  const getMeetingById = useCallback(async () => {
    try {
      const meetingId = params?.id;
      setNewMeetingId(meetingId!);
      setLoadingMeeting(true);
      if (meetingId) {
        const response: Meeting = await getMeetingByIdRequest(
          meetingId as string,
          user?.id as string,
        );

        setValue('title', response.title);
        setValue(
          'start_at',
          dayjs(response.start_at).format('YYYY-MM-DDTHH:mm'),
        );
        setValue('duration', response.duration);
        setListaConvidados(response.guests);

        setValue('link_address', response.link_address);
        setValue('local_address', response.local_address);
        setRecurrenceTotal(response.recurrence_meetings?.length || 0);

        setLinkZoomRemoved(!response?.refresh_token_zoom);

        const orderedRecurrence = _.orderBy(
          response.recurrence_meetings,
          'start_at',
        );

        orderedRecurrence?.map((m, i) => {
          if (m.id === response.id) {
            return setRecurrencePosition(i + 1);
          }
          return 0;
        });

        const responseUsers = await getUsersByCompanyIdRequest(
          selectedCompany?.id as string,
          searchForUsers,
          '',
          '100',
          '',
        );

        setListaUsuariosTheme(responseUsers?.data?.data);

        if (
          response.board &&
          (response.board.members as BoardMember[]).length > 0
        ) {
          const usuarios = response.board?.members?.map((u: any) => ({
            ...u,
            profile: 'GS2',
            selected: false,
          }));

          const guests: any = response.guests?.map((u: Guest) => ({
            ...u,
            selected: true,
          }));

          const usuariosFiltrados = _.differenceBy(
            usuarios as any,
            guests as any,
            'id',
          );

          const todosUsuarios = guests?.concat(usuariosFiltrados as any);

          setListaUsuarios(todosUsuarios as any);
        }

        setMeetingSelect(response);
        setSelectedMeetingStore(response);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoadingMeeting(false);
    }
  }, [
    params?.id,
    user?.id,
    setValue,
    selectedCompany?.id,
    searchForUsers,
    setSelectedMeetingStore,
  ]);

  const getFilesToVerify = useCallback(async () => {
    const files = listagemTemas?.map(theme => theme.files);

    if (files) {
      const verifyIfHaveSomeFile = files?.filter(f => f && f?.length > 0);
      setFilesToVerify(verifyIfHaveSomeFile as any);
    }
  }, [listagemTemas]);

  // const changeStatusToMinuteSigned = useCallback(async () => {
  //   try {
  //     const data: Partial<Meeting> = {
  //       status: 'MS5',
  //     };

  //     const response = await updateMeetingRequest(
  //       data,
  //       meetingSelect?.id as string,
  //       user?.id as string,
  //       selectedCompany?.id as string,
  //     );

  //     if (response?.status === 200) {
  //       handleNext();
  //     }
  //   } catch (err) {
  //     console.log(err);
  //   }
  // }, [handleNext, meetingSelect?.id, selectedCompany?.id, user?.id]);

  // const changeStatusToMinuteInserted = useCallback(async () => {
  //   try {
  //     const data: Partial<Meeting> = {
  //       status: 'MS4',
  //     };

  //     const response = await updateMeetingRequest(
  //       data,
  //       meetingSelect?.id as string,
  //       user?.id as string,
  //       selectedCompany?.id as string,
  //     );

  //     if (response?.status === 200) {
  //       setDateToAddMinute(date);
  //     }
  //   } catch (err) {
  //     console.log(err);
  //   }
  // }, [date, meetingSelect?.id, selectedCompany?.id, user?.id]);

  useEffect(() => {
    if (meetingSelect) {
      switch (meetingSelect?.status) {
        case 'MS1':
          setActiveStep(0);
          break;
        case 'MS2':
          setActiveStep(1);
          setThemesFinish(true);
          break;
        case 'MS3':
          setActiveStep(2);
          setThemesFinish(true);
          setMeetingFinish(true);
          break;
        case 'MS4':
          setActiveStep(3);
          setThemesFinish(true);
          setMeetingFinish(true);
          break;
        case 'MS5':
          setActiveStep(4);
          setMeetingFinish(true);
          setThemesFinish(true);
          break;
        default:
          console.log('Nada');
          break;
      }
    }
  }, [meetingSelect]);

  // useEffect(() => {
  //   if (minute?.name) {
  //     changeStatusToMinuteInserted();
  //   }
  // }, [minute]);

  useEffect(() => {
    if (params?.id) {
      getMeetingById();
    }
  }, [params]);

  // useEffect(() => {
  //   if (meetingSelect?.ata_url) {
  //     changeStatusToMinuteSigned();
  //   }
  // }, [meetingSelect]);

  useEffect(() => {
    if (meetingSelect?.folder_id) {
      getFilesToVerify();
    }
  }, [meetingSelect, listagemTemas]);

  useEffect(() => {
    async function loadThemesByMeetingId(meetingId: string) {
      const response = await getThemesByMeetingIdRequest(
        meetingId,
        user?.id as string,
      );

      if (response?.status === 200) {
        setListagemTemas(response?.data);
      }
    }

    if (params?.id) {
      loadThemesByMeetingId(params?.id as string);
    }
  }, [params, user?.id]);

  const handleEditMeeting = useCallback(
    async (formData: any) => {
      const meetingId = params?.id;
      try {
        if (userFiltered?.profile === 'GS1') {
          const meeting = {
            title: formData.title,
            start_at: convertStringToDateToSave(formData.start_at),
            duration: formData.duration,
            local_address: formData.local_address || null,
            link_address: linkJitsiRemoved ? null : formData?.link_address,
            refresh_token_zoom: linkZoomRemoved
              ? null
              : meetingSelect?.refresh_token_zoom,
          };

          const redirectUrlZoom = authorizationCode
            ? `${process.env.REACT_APP_API_URL}/autenticacao-sucesso`
            : null;

          const response = await updateMeetingRequest(
            meeting as any,
            meetingId as string,
            user?.id as string,
            selectedCompany?.id as string,
            jitsiActived,
            authorizationCode,
            redirectUrlZoom,
          );

          if (response?.status === 200) {
            const meetingEditada = response?.data;

            setMeetingSelect({ ...meetingEditada });
            toast.success('Reunião editada com sucesso');
            setZoomActived(false);
            setAuthorizationCode(null);
            setLinkJitsiRemoved(false);
          }
          setOpenDrawerEditMeeting(false);
          getMeetingById();

          setOpenDrawerEditMeeting(false);
          getMeetingById();
          // }
        } else {
          toast.warning('Você não tem permissão para editar esta reunião');
        }
      } catch (error) {
        console.log({ error });
      }
    },
    [
      params?.id,
      userFiltered?.profile,
      linkJitsiRemoved,
      linkZoomRemoved,
      meetingSelect?.refresh_token_zoom,
      authorizationCode,
      user?.id,
      selectedCompany?.id,
      jitsiActived,
      getMeetingById,
    ],
  );

  const handleGuestEdit = useCallback(async () => {
    const meetingId = params?.id;
    try {
      setLoadingRequest(true);
      if (userFiltered?.profile === 'GS1' || user?.profile === 'UN1') {
        const guests = listaConvidados?.map(m => ({
          id: m.id,
          name: m.name,
          email: m.email,
          profile: m.profile,
          status: m.status,
          avatar_url: m.avatar_url,
        }));

        const meeting = {
          guests,
          refresh_token_zoom: meetingSelect?.refresh_token_zoom,
        };

        const response = await updateMeetingRequest(
          meeting as any,
          meetingId as string,
          user?.id as string,
          selectedCompany?.id as string,
        );

        if (response?.status === 200) {
          const meetingEditada = response?.data;

          setMeetingSelect({ ...meetingEditada });
          toast.success('Convidados editados com sucesso');
        }
        setOpenDrawerEditMembers(false);
        getMeetingById();
      } else {
        toast.warning('Você não tem permissão para editar membros');
      }
    } catch (error) {
      console.log({ error });
    } finally {
      setLoadingRequest(false);
    }
  }, [
    params?.id,
    userFiltered?.profile,
    listaConvidados,
    meetingSelect?.refresh_token_zoom,
    user?.profile,
    user?.id,
    selectedCompany?.id,
    getMeetingById,
  ]);

  const handleUserToInvite = useCallback(
    (
      event: React.MouseEvent<unknown>,
      name: string,
      usr: GuestToSelect,
      idx: number,
      type: 'select' | 'profile',
    ) => {
      event.stopPropagation();
      let listaUsuariosEditada = { ...usr };

      if (type === 'select') {
        listaUsuariosEditada.selected = !usr?.selected;
      }

      if (type === 'profile') {
        listaUsuariosEditada.profile = usr?.profile === 'GS1' ? 'GS2' : 'GS1';
      }

      listaUsuarios?.splice(idx, 1, listaUsuariosEditada);

      setListaUsuarios([...listaUsuarios!]);
      const usuariosConvidados = listaUsuarios?.filter(u => u.selected);
      setListaConvidados([...usuariosConvidados!]);
    },
    [listaUsuarios],
  );

  const handleRemoveMeeting = useCallback(async () => {
    try {
      setLoadingCancel(true);

      const response = await cancelMeetingRequest(
        newMeetingId,
        user?.id as string,
        selectedCompany?.id as string,
      );

      if (response?.status === 200) {
        setDialogCancelOpen(false);
        setOpenDrawerEditMeeting(false);
        getMeetingById();
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoadingCancel(false);
    }
  }, [newMeetingId, user, selectedCompany, getMeetingById]);

  const handleReactiveMeeting = useCallback(async () => {
    try {
      setIsSubmitting(true);

      const response = await activeMeetingRequest(
        newMeetingId,
        selectedCompany?.id as string,
        user?.id as string,
      );

      if (response?.status === 200) {
        setDialogActiveOpen(false);
        getMeetingById();
      }
    } catch (err) {
      console.log(err);
    } finally {
      setIsSubmitting(false);
    }
  }, [newMeetingId, selectedCompany?.id, user?.id, getMeetingById]);

  const handleFinishedThemes = useCallback(async () => {
    try {
      setIsSubmitting(true);

      const data: Partial<Meeting> = {
        status: 'MS2',
        refresh_token_zoom: meetingSelect?.refresh_token_zoom,
      };

      const response = await updateMeetingRequest(
        data,
        meetingSelect?.id as string,
        user?.id as string,
        selectedCompany?.id as string,
      );

      if (response?.status === 200) {
        setThemesFinish(true);
        setOpenModalThemes(false);
        setDateToFinishedThemes(date);
        handleNext();
        toast.success('Pautas fechadas com sucesso');

        if (checked) {
          await sendNotificationThemesRequest(meetingSelect?.id as string);
        }
      }
    } catch (err) {
      console.log(err);
    } finally {
      setIsSubmitting(false);
    }
  }, [
    checked,
    date,
    handleNext,
    meetingSelect?.id,
    meetingSelect?.refresh_token_zoom,
    selectedCompany?.id,
    user?.id,
  ]);

  const handleFinishedMeeting = useCallback(async () => {
    try {
      setIsSubmitting(true);

      const data: Partial<Meeting> = {
        status: 'MS3',
        refresh_token_zoom: meetingSelect?.refresh_token_zoom,
      };

      const response = await updateMeetingRequest(
        data,
        meetingSelect?.id as string,
        user?.id as string,
        selectedCompany?.id as string,
      );

      if (response?.status === 200) {
        setMeetingFinish(true);
        setOpenModalFinishedMeeting(false);
        setDateToFinishedMeeting(date);
        handleNext();
        toast.success('Reunião Realizada com sucesso');
      }
    } catch (err) {
      console.log(err);
    } finally {
      setIsSubmitting(false);
    }
  }, [
    date,
    handleNext,
    meetingSelect?.id,
    meetingSelect?.refresh_token_zoom,
    selectedCompany?.id,
    user?.id,
  ]);

  const handleBackToOpenThemes = useCallback(async () => {
    try {
      setIsSubmitting(true);
      const data: Partial<Meeting> = {
        status: 'MS1',
        refresh_token_zoom: meetingSelect?.refresh_token_zoom,
      };

      const response = await updateMeetingRequest(
        data,
        meetingSelect?.id as string,
        user?.id as string,
        selectedCompany?.id as string,
      );

      if (response?.status === 200) {
        setThemesFinish(false);
        setOpenModalReOpenThemes(false);
        setDateToFinishedThemes(null);
        handleGoback();
        toast.success('Pautas reabertas com sucesso');
      }
    } catch (err) {
      console.log(err);
    } finally {
      setIsSubmitting(false);
    }
  }, [
    handleGoback,
    meetingSelect?.id,
    meetingSelect?.refresh_token_zoom,
    selectedCompany?.id,
    user?.id,
  ]);

  const loadNotes = useCallback(async () => {
    setLoadingNotes(true);
    try {
      const response = await getNotesByUserIdAndMeetingIdRequest(
        user?.id as string,
        params?.id as string,
      );

      if (response?.status === 200) {
        const usuarios = listaConvidados?.map((u: Guest) => ({
          ...u,
          selectedNote: false,
        }));

        const guestsNotes = response?.data?.viewers?.map((u: Guest) => ({
          ...u,
          selectedNote: true,
        }));

        const usuariosFiltrados = _.differenceBy(usuarios, guestsNotes, 'id');

        if (guestsNotes) {
          const todosUsuarios = guestsNotes?.concat(usuariosFiltrados);
          const guestsWithoutOwner = todosUsuarios?.filter(
            (m: any) => m?.id !== user?.id,
          );
          setListaUserNote(guestsWithoutOwner);
        } else {
          const guestsWithoutOwner = usuariosFiltrados?.filter(
            (m: any) => m?.id !== user?.id,
          );
          setListaUserNote(guestsWithoutOwner);
        }

        setNota(response?.data);
        setValueNote(response?.data?.description);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoadingNotes(false);
    }
  }, [listaConvidados, params?.id, user?.id]);

  useEffect(() => {
    if (user && params?.id) {
      loadNotes();
    }
  }, [user, params, openDrawerAnotacao]);

  const handleRemoveNote = useCallback(async () => {
    try {
      const response = await deleteNoteRequest(nota?.id as string);

      if (response?.status === 200) {
        setNota({} as Note);
        setValueNote('');
        setOpenDrawerAnotacao(false);
        setOpenModalDeleteNote(false);
      }
    } catch (error) {
      console.log({ error });
    }
  }, [nota]);

  const handleUserToInviteNote = useCallback(
    (
      event: React.MouseEvent<unknown>,
      name: string,
      usr: GuestToSelectNote,
      idx: number,
      type: 'select',
    ) => {
      let listaUsuariosNotesEditada = { ...usr };

      if (type === 'select') {
        listaUsuariosNotesEditada.selectedNote = !usr?.selectedNote;
      }

      listaUsersNote?.splice(idx, 1, listaUsuariosNotesEditada);

      setListaUserNote([...listaUsersNote!]);
      const usuariosConvidados = listaUsersNote?.filter(u => u.selectedNote);
      setListaConvidadosNotes([...usuariosConvidados!]);
    },
    [listaUsersNote, setListaUserNote, setListaConvidadosNotes],
  );

  const handleCreateNote = useCallback(async () => {
    if (valueNote) {
      try {
        setLoadingRequest(true);

        const noteId = nota?.id;
        let response;

        const viewers = listaConvidadosNotes.map(e => ({
          name: e.name,
          id: e.id,
          email: e.email,
          avatar_url: e.avatar_url,
        }));

        const viewers_ids = listaConvidadosNotes.map(e => e.id);

        const note = {
          title: meetingSelect.title,
          meeting_id: meetingSelect?.id,
          description: valueNote as string,
          viewers,
          viewers_ids,
        };

        if (noteId) {
          response = await updateNoteRequest(
            note as any,
            noteId,
            selectedCompany?.id as string,
            user?.id as string,
          );
        } else {
          response = await createNoteRequest(note as any, user?.id as string);
        }

        if (response?.status === 201 || response?.status === 200) {
          setOpenDrawerAnotacao(false);
          setNota(response?.data);
        }
      } catch (error) {
        console.log({ error });
      } finally {
        setLoadingRequest(false);
      }
    }
  }, [
    valueNote,
    nota?.id,
    listaConvidadosNotes,
    meetingSelect.title,
    meetingSelect?.id,
    selectedCompany?.id,
    user?.id,
  ]);

  const handleCreateInvite = useCallback(async () => {
    try {
      setLoadingSendInvite(true);
      setOpenModalToCreateInvite(false);
      const response = await sendMeetingInviteRequest(
        meetingSelect?.id as string,
        user?.id as string,
      );

      if (response?.status === 201) {
        setOpenModalSuccessInvite(true);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoadingSendInvite(false);
      const meetingUpdated = {
        ...meetingSelect,
        has_invite: true,
      };

      setMeetingSelect(meetingUpdated);
    }
  }, [meetingSelect, user?.id]);

  const handleSelectAllClick = () => {
    setSelectedAll(prev => !prev);
  };

  useEffect(() => {
    if (selectedAll === null) {
      const users = listaUsuarios?.map(u => ({
        ...u,
        profile: 'GS2',
      }));
      setListaUsuarios([...(users as any)]);
      setListaConvidados([...(users as any)]);
    } else if (selectedAll === false) {
      const usersUnselected = listaUsuarios?.map(u => ({
        ...u,
        profile: 'GS2',
        selected: false,
      }));
      setListaUsuarios([...(usersUnselected as any)]);
      setListaConvidados([]);
    } else if (selectedAll === true) {
      const usersSelected = listaUsuarios?.map(u => ({
        ...u,
        profile: 'GS2',
        selected: true,
      }));
      setListaUsuarios([...(usersSelected as any)]);
      setListaConvidados([...(usersSelected as any)]);
    }
  }, [selectedAll]);

  const drawerEditMembros = () => (
    <Box
      width="560px"
      padding="20px"
      height="100%"
      display="flex"
      flexDirection="column"
    >
      <SectionHeaderDrawer sx={{ marginBottom: '20px' }}>
        <CloseRounded
          sx={{ cursor: 'pointer', position: 'absolute', left: '0' }}
          onClick={() => setOpenDrawerEditMembers(false)}
        />
        <BoxText className="title">Editar participantes</BoxText>
      </SectionHeaderDrawer>
      <StepMembros
        handleNext={() => setOpenDrawerEditMembers(false)}
        handleBack={() => setOpenDrawerEditMembers(false)}
        users={listaUsuarios}
        members={listaConvidados}
        handleUserToInvite={handleUserToInvite}
        handleEditMeeting={handleGuestEdit}
        loadingRequest={loadingRequest}
        handleSelectedAll={handleSelectAllClick}
        selectedAll={selectedAll}
        setSelectedAll={setSelectedAll}
      />
    </Box>
  );

  const drawerEditDadosMeeting = () => (
    <Box width="560px" padding="20px" height="100%">
      <EditarReuniao
        handleMeeting={handleEditMeeting}
        setOpenDrawerEditMeeting={setOpenDrawerEditMeeting}
        handleRemoveMeeting={handleRemoveMeeting}
        setDialogCancelOpen={setDialogCancelOpen}
        dialogCancelOpen={dialogCancelOpen}
        linkZoomRemoved={linkZoomRemoved}
        setLinkZoomRemoved={setLinkZoomRemoved}
        authorizationCode={authorizationCode}
        setAuthorizationCode={setAuthorizationCode}
        zoomActived={zoomActived}
        setZoomActived={setZoomActived}
        setLoadingZoom={setLoadingZoom}
        hasJitsi={hasJitsi}
        setHasJitsi={setHasJitsi}
        jitsiActived={jitsiActived}
        setJitsiActived={setJitsiActived}
        linkJitsiRemoved={linkJitsiRemoved}
        setLinkJitsiRemoved={setLinkJitsiRemoved}
      />
      <ConfirmModal
        open={dialogCancelOpen}
        onClose={() => setDialogCancelOpen(false)}
        onCancel={() => setDialogCancelOpen(false)}
        onConfirm={handleRemoveMeeting}
        title="Deseja realmente cancelar esta reunião?"
        subtitle="Ao confirmar, a reunião será cancelada e todos os participantes receberão uma notificação por e-mail."
        btnTextConfirm="Confirmar"
        btnTextCancel="Cancelar"
        type="error"
        isSubmitting={loadingCancel}
      />
    </Box>
  );

  const drawerAnotacao = () => (
    <Box
      width="480px"
      padding="20px"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        height: '100%',
      }}
    >
      <SectionHeaderDrawer>
        <CloseRounded
          sx={{ cursor: 'pointer', position: 'absolute', left: '0' }}
          onClick={() => setOpenDrawerAnotacao(false)}
        />
        <BoxText className="title">Anotações</BoxText>
      </SectionHeaderDrawer>
      <Page>
        <form>
          <Box>
            <TextField
              placeholder="Escreva sua anotação"
              style={{
                width: '100%',
                height: '200px',
              }}
              multiline
              rows={8}
              value={valueNote}
              onChange={ev => setValueNote(ev.target.value)}
            />
            {listaUsersNote?.length > 0 ? (
              <>
                {loadingNotes ? (
                  <Box
                    display="flex"
                    justifyContent="center"
                    width="100%"
                    mt="150px"
                  >
                    <CircularProgress />
                  </Box>
                ) : (
                  <>
                    <BoxText mt="20px">
                      <span className="title">
                        Compartilhe sua anotação com outros membros
                      </span>
                    </BoxText>
                    <Box
                      display="flex"
                      flexDirection="row"
                      width="100%"
                      justifyContent="start"
                      mt="20px"
                    >
                      <span className="desc">Nome</span>
                    </Box>
                    <ContainerUsers>
                      <Box>
                        {listaUsersNote?.map((u, index) => (
                          <Box>
                            <Users
                              onClick={event =>
                                handleUserToInviteNote(
                                  event,
                                  u.name,
                                  u,
                                  index,
                                  'select',
                                )
                              }
                            >
                              <Box
                                display="flex"
                                flexDirection="row"
                                gap="10px"
                              >
                                {u?.avatar_url ? (
                                  <Avatar sx={{ width: '40px' }}>
                                    <img
                                      src={u?.avatar_url as string}
                                      alt="Foto de perfil"
                                      style={{ width: '100%' }}
                                    />
                                  </Avatar>
                                ) : (
                                  <Avatar
                                    {...stringAvatar(u.name!)}
                                    sx={{ width: '40px' }}
                                  />
                                )}
                                <span className="name">{u.name}</span>
                              </Box>
                              <Checkbox
                                color="primary"
                                checked={u.selectedNote === true}
                                // sx={{ padding: '0' }}
                              />
                            </Users>
                          </Box>
                        ))}
                      </Box>
                    </ContainerUsers>
                  </>
                )}
              </>
            ) : (
              <Box mt="20px">
                <BoxText>
                  Adicione membros a reunião para compartilhar sua anotação.
                </BoxText>
              </Box>
            )}
          </Box>

          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              gap: '10px',
              width: '100%',
              justifyContent: nota?.id ? 'space-between' : 'end',
            }}
          >
            {nota?.id && (
              <Button
                color="error"
                variant="outlined"
                onClick={() => setOpenModalDeleteNote(true)}
              >
                Deletar anotação
              </Button>
            )}
            <ConfirmModal
              open={openModalDeleteNote}
              onClose={() => setOpenModalDeleteNote(false)}
              onCancel={() => setOpenModalDeleteNote(false)}
              onConfirm={handleRemoveNote}
              title="Deletar anotação"
              subtitle="Deseja realmente deletar esta anotação"
              btnTextConfirm="Confirmar"
              btnTextCancel="Cancelar"
              type="error"
            />
            <Button
              name="submitbtn"
              type="button"
              onClick={handleCreateNote}
              disabled={loadingRequest}
              variant="contained"
              color="success"
              sx={{ color: '#ffffff' }}
            >
              Salvar alterações
            </Button>
          </Box>
        </form>
      </Page>
    </Box>
  );

  return (
    <Container>
      {loadingZoom && (
        <LoadingBackdrop
          loading={loadingZoom}
          text="Autenticando com sua conta Zoom"
          component=""
        />
      )}
      {loadingMeeting ? (
        <Box
          width="100%"
          height="100%"
          display="flex"
          justifyContent="center"
          alignItems="center"
        >
          <CircularProgress />
        </Box>
      ) : (
        <>
          <Header>
            <Button
              className="btn-back"
              variant="outlined"
              onClick={() => navigate(-1)}
            >
              <ArrowBack /> Voltar
            </Button>
            <span>#{meetingSelect.id?.slice(0, 8)}</span>
          </Header>
          {meetingSelect?.canceled_at ? null : (
            <SectionMeeting sx={{ flexDirection: 'column', padding: '30px 0' }}>
              <Stepper
                alternativeLabel
                activeStep={activeStep}
                connector={<ColorLibConnector />}
                sx={{ width: '100%' }}
              >
                {stepsLabel.map(label => (
                  <Step key={label.name}>
                    <StepLabel StepIconComponent={ColorlibStepIcon}>
                      {activeStep === 0 && (
                        <BoxText>
                          {label.name} {label.disableNameForThemes}
                          {label.disableNameForMinute}
                          {label.disableNameToSign}
                        </BoxText>
                      )}
                      {activeStep === 1 || activeStep === 2 ? (
                        <BoxText>
                          {label.name} {label.activeNameForThemes}
                          {label.disableNameForMinute} {label.disableNameToSign}
                        </BoxText>
                      ) : null}
                      {activeStep === 3 && (
                        <BoxText>
                          {label.name} {label.activeNameForThemes}
                          {label.activeNameForMinute} {label.disableNameToSign}
                        </BoxText>
                      )}
                      {activeStep === 4 && (
                        <BoxText>
                          {label.name} {label.activeNameForThemes}
                          {label.activeNameForMinute} {label.activeNameToSign}
                        </BoxText>
                      )}
                    </StepLabel>
                  </Step>
                ))}
              </Stepper>
              <Box
                width="100%"
                display="flex"
                justifyContent="center"
                alignItems="center"
              >
                <Box
                  width="100%"
                  display="flex"
                  flexDirection="column"
                  alignItems="center"
                  justifyContent="center"
                  marginTop="10px"
                >
                  <BoxText sx={{ color: '#9E9E9E' }}>
                    {dayjs(meetingSelect?.created_at).format('DD/MM/YYYY')}
                  </BoxText>
                </Box>
                <Box width="100%" display="flex" justifyContent="center">
                  {themesFinish ? (
                    <Box
                      display="flex"
                      flexDirection="column"
                      alignItems="center"
                      justifyContent="center"
                      marginTop="10px"
                    >
                      {/* <BoxText sx={{ color: '#9E9E9E' }}>{date}</BoxText> */}
                      {!meetingFinish && (
                        <>
                          {userFiltered?.profile === 'GS1' && (
                            <Button
                              variant="outlined"
                              onClick={() => setOpenModalReOpenThemes(true)}
                              sx={{ marginTop: '9px' }}
                            >
                              Reabrir pautas
                            </Button>
                          )}
                          <ConfirmModal
                            btnTextCancel="Cancelar"
                            btnTextConfirm="Confirmar"
                            onCancel={() => setOpenModalReOpenThemes(false)}
                            onClose={() => setOpenModalReOpenThemes(false)}
                            onConfirm={handleBackToOpenThemes}
                            open={openModalReOpenThemes}
                            subtitle="Deseja realmente reabrir as pautas? Ao continuar você poderá editar o conteúdo das pautas e ao fechar novamente, os participantes serão notificados da atualização."
                            title="Reabrir pautas"
                            type="success"
                            isSubmitting={isSubmitting}
                          />
                        </>
                      )}
                    </Box>
                  ) : (
                    <>
                      {userFiltered?.profile === 'GS1' && (
                        <Button
                          variant="outlined"
                          sx={{ marginTop: '9px' }}
                          onClick={() => setOpenModalThemes(true)}
                        >
                          Fechar Pautas
                        </Button>
                      )}
                      <ModalCloseThemes
                        open={openModalThemes}
                        onClose={() => setOpenModalThemes(false)}
                        onCancel={() => setOpenModalThemes(false)}
                        onConfirm={handleFinishedThemes}
                        checked={checked}
                        handleChange={handleChange}
                        isSubmitting={isSubmitting}
                      />
                    </>
                  )}
                </Box>
                <Box
                  width="100%"
                  display="flex"
                  flexDirection="column"
                  alignItems="center"
                  justifyContent="center"
                  marginTop="10px"
                >
                  <Box>
                    {themesFinish && !meetingFinish && (
                      <>
                        {userFiltered?.profile === 'GS1' && (
                          <Button
                            variant="outlined"
                            sx={{ marginTop: '9px' }}
                            onClick={() => setOpenModalFinishedMeeting(true)}
                          >
                            Realizada
                          </Button>
                        )}
                        <ConfirmModal
                          btnTextCancel="Cancelar"
                          btnTextConfirm="Confirmar"
                          onCancel={() => setOpenModalFinishedMeeting(false)}
                          onClose={() => setOpenModalFinishedMeeting(false)}
                          onConfirm={handleFinishedMeeting}
                          open={openModalFinishedMeeting}
                          subtitle="Ao marcar a reunião como realizada você não poderá mais editar as pautas e habilitará a ata para ser inserida."
                          title="Marcar reunião como realizada"
                          type="success"
                          isSubmitting={isSubmitting}
                        />
                      </>
                    )}
                    {/* {themesFinish && meetingFinish ? (
                      <BoxText sx={{ color: '#9E9E9E' }}>{date}</BoxText>
                    ) : null} */}
                  </Box>
                </Box>
                <Box
                  width="100%"
                  display="flex"
                  flexDirection="column"
                  alignItems="center"
                  justifyContent="center"
                  marginTop="10px"
                >
                  {/* {activeStep >= 3 && (
                    <BoxText sx={{ color: '#9E9E9E' }}>{date}</BoxText>
                  )} */}
                </Box>
                <Box
                  width="100%"
                  display="flex"
                  flexDirection="column"
                  alignItems="center"
                  justifyContent="center"
                  marginTop="10px"
                >
                  {/* {activeStep === 4 && (
                    <BoxText sx={{ color: '#9E9E9E' }}>{date}</BoxText>
                  )} */}
                </Box>
              </Box>
            </SectionMeeting>
          )}
          <SectionMeeting justifyContent="space-between">
            <Div
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: '10px',
              }}
            >
              <BoxText
                className="title-meeting"
                sx={{
                  color: meetingSelect?.canceled_at ? '#d62237' : '#000000',
                }}
              >
                {meetingSelect.title}
              </BoxText>
              <BoxText
                className="text-meeting"
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  gap: '10px',
                  alignItems: 'center',
                  height: '32px',
                }}
              >
                <GroupsRounded /> {meetingSelect?.board?.title}
              </BoxText>
              <BoxText
                className="text-meeting"
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  gap: '10px',
                  alignItems: 'center',
                  height: '32px',
                  textDecorationLine: meetingSelect?.canceled_at
                    ? 'line-through'
                    : '',
                }}
              >
                <CalendarTodayRounded />{' '}
                {dayjs(meetingSelect.start_at).format(
                  'dddd, D MMMM, YYYY HH:mm',
                )}
                <React.Fragment key="right">
                  {recurrenceTotal > 1 && (
                    <RecurrenceButton
                      onClick={() => setOpenDrawerRecurrence(true)}
                      className="btn-repetition"
                      variant="text"
                    >
                      <RefreshOutlined /> Recorrência {recurrencePosition}/
                      {recurrenceTotal}
                    </RecurrenceButton>
                  )}

                  <SwipeableDrawer
                    anchor="right"
                    open={openDrawerRecurrence}
                    onClose={() => setOpenDrawerRecurrence(false)}
                    onOpen={() => setOpenDrawerRecurrence(true)}
                    ModalProps={{
                      keepMounted: true,
                    }}
                  >
                    <RecurrenceList
                      recurrencesList={
                        meetingSelect?.recurrence_meetings as any
                      }
                      handleCancel={() => setOpenDrawerRecurrence(false)}
                    />
                  </SwipeableDrawer>
                </React.Fragment>
              </BoxText>
              <BoxText
                className="text-meeting"
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  gap: '10px',
                  alignItems: 'center',
                  height: '32px',
                  textDecorationLine: meetingSelect?.canceled_at
                    ? 'line-through'
                    : '',
                }}
              >
                <AccessTimeRounded /> {meetingSelect.duration} minutos
              </BoxText>
              {meetingSelect?.canceled_at ? (
                ''
              ) : (
                <BoxText
                  className="text-meeting"
                  sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    gap: '10px',
                    height: '32px',
                    alignItems: 'center',
                  }}
                >
                  <PinDropRounded />{' '}
                  {meetingSelect?.local_address
                    ? meetingSelect.local_address
                    : 'Não foi adicionado nenhum endereço'}
                </BoxText>
              )}
              {meetingSelect?.canceled_at ? (
                ''
              ) : (
                <BoxText
                  className="text-meeting"
                  sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    gap: '10px',
                    alignItems: 'center',
                    height: '32px',
                  }}
                >
                  <OndemandVideoRounded />{' '}
                  {meetingSelect?.link_address ? (
                    <a
                      href={meetingSelect?.link_address as string}
                      target="_blank"
                      rel="noreferrer"
                      className="link-meeting"
                    >
                      Acessar link da reunião
                      {meetingSelect?.link_address.includes('zoom') &&
                        ' (Zoom)'}
                    </a>
                  ) : (
                    'Não foi adicionado nenhum link'
                  )}
                </BoxText>
              )}
            </Div>
            <Div
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: '10px',
              }}
            >
              {meetingSelect?.canceled_at && (
                <Box display="flex" flexDirection="column" gap="10px">
                  <Button
                    color="error"
                    variant="contained"
                    sx={{
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: 'center',
                      alignItems: 'center',
                      padding: '6px 16px 6px 12px',
                      gap: '8px',
                      width: '204px',
                      height: '40px',
                    }}
                  >
                    Reunião Cancelada
                  </Button>
                  {userFiltered?.profile === 'GS1' && (
                    <Button
                      variant="outlined"
                      onClick={() => setDialogActiveOpen(true)}
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'center',
                        alignItems: 'center',
                        padding: '6px 16px 6px 12px',
                        gap: '8px',
                        width: '204px',
                        height: '40px',
                        fontFamily: 'Roboto',
                        fontStyle: 'normal',
                        fontWeight: '500',
                        fontSize: '14px',
                        lineHeight: '14px',
                      }}
                    >
                      <RefreshRounded /> Reativar Reunião
                    </Button>
                  )}
                </Box>
              )}

              <ConfirmModal
                open={dialogActiveOpen}
                onClose={() => setDialogActiveOpen(false)}
                onCancel={() => setDialogActiveOpen(false)}
                onConfirm={handleReactiveMeeting}
                title="Deseja realmente reativar esta reunião?"
                subtitle="Ao confirmar, a reunião será reativada!"
                btnTextConfirm="Confirmar"
                btnTextCancel="Cancelar"
                type="warning"
                isSubmitting={isSubmitting}
              />

              {userFiltered?.profile === 'GS1' &&
                (!meetingSelect?.canceled_at ? (
                  <Button
                    variant="contained"
                    sx={{
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: 'center',
                      alignItems: 'center',
                      padding: '6px 16px 6px 12px',
                      gap: '8px',
                      width: '204px',
                      height: '40px',
                    }}
                    onClick={() => setOpenDrawerEditMeeting(true)}
                  >
                    <EditRounded /> Editar Dados
                  </Button>
                ) : null)}
              <SwipeableDrawer
                anchor="right"
                open={openDrawerEditMeeting}
                onOpen={() => setOpenDrawerEditMeeting(true)}
                onClose={() => setOpenDrawerEditMeeting(true)}
              >
                {drawerEditDadosMeeting()}
              </SwipeableDrawer>
              {userFiltered?.profile === 'GS1' &&
                !meetingSelect?.has_invite &&
                !meetingSelect?.canceled_at && (
                  <Button
                    variant="outlined"
                    sx={{
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: 'center',
                      alignItems: 'center',
                      padding: '6px 16px 6px 12px',
                      gap: '8px',
                      width: '204px',
                      height: '40px',
                    }}
                    onClick={() => setOpenModalToCreateInvite(true)}
                  >
                    <CalendarTodayRounded /> Criar invite
                  </Button>
                )}
              <ConfirmModal
                open={openModalToCreateInvite}
                onClose={() => setOpenModalToCreateInvite(true)}
                onCancel={() => setOpenModalToCreateInvite(false)}
                title="Criar invite"
                subtitle="Todos os participantes receberão um e-mail com invite de convocação desta reunião."
                btnTextConfirm="Confirmar"
                btnTextCancel="Cancelar"
                type="success"
                onConfirm={handleCreateInvite}
              />
              <ModalSuccessInvite
                open={openModalSuccessInvite}
                onClose={() => setOpenModalSuccessInvite(false)}
                onCancel={() => setOpenModalSuccessInvite(false)}
                onConfirm={() => setOpenModalSuccessInvite(false)}
              />
              {/* <Button
                variant="outlined"
                onClick={() => setOpenModalDuplicar(true)}
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'center',
                  alignItems: 'center',
                  padding: '6px 16px 6px 12px',
                  gap: '8px',
                }}
              >
                <ContentCopyRounded /> Duplicar reuniao
              </Button> */}
              {/* <ConfirmModal
                open={openModalDuplicar}
                onClose={() => setOpenModalDuplicar(true)}
                onCancel={() => setOpenModalDuplicar(false)}
                title="Duplicar reunião"
                subtitle="Todos os dados, participantes, pautas e arquivos serão duplicados, deseja prosseguir?"
                btnTextConfirm="Confirmar"
                btnTextCancel="Cancelar"
                type="success"
                onConfirm={() => setOpenDrawerEditMeeting(false)} // alterar
              /> */}

              {/* {meetingSelect?.guests_ids?.includes(user?.id as string) && (
                <React.Fragment key="right">
                  {meetingSelect?.canceled_at ? (
                    ''
                  ) : (
                    <Button
                      variant="outlined"
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'center',
                        alignItems: 'center',
                        padding: '6px 16px 6px 12px',
                        width: '204px',
                        height: '40px',
                        gap: '8px',
                      }}
                      onClick={() => setOpenDrawerAnotacao(true)}
                    >
                      <NotesRounded /> Anotação
                    </Button>
                  )}
                  <SwipeableDrawer
                    anchor="right"
                    onClose={() => setOpenDrawerAnotacao(false)}
                    onOpen={() => setOpenDrawerAnotacao(true)}
                    open={openDrawerAnotacao}
                  >
                    {drawerAnotacao()}
                  </SwipeableDrawer>
                </React.Fragment>
              )} */}
              {/* {meetingSelect?.canceled_at && (
              <>
                <Button
                  variant="outlined"
                  sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'center',
                    alignItems: 'center',
                    padding: '6px 16px 6px 12px',
                    gap: '8px',
                  }}
                  onClick={() => setDialogReactiveMeeting(true)}
                >
                  <RefreshRounded /> Reativar reunião
                </Button>
                <ConfirmModal
                  open={dialogReactiveMeeting}
                  onClose={() => setDialogReactiveMeeting(false)}
                  onCancel={() => setDialogReactiveMeeting(false)}
                  onConfirm={() => handleReactiveReuniao(meetingSelect, 'MS1')}
                  title="Reativar reunião"
                  subtitle="Ao confirmar, a reunião será reativada. Deseja prosseguir?"
                  btnTextCancel="CANCELAR"
                  btnTextConfirm="confirmar"
                  type="success"
                />
              </>
            )} */}
            </Div>
          </SectionMeeting>
          <SectionMeeting>
            <Box width="100%">
              <Box
                display="flex"
                alignItems="center"
                justifyContent="space-between"
                width="100%"
              >
                <TitleMembers>Participantes</TitleMembers>
                <React.Fragment key="right">
                  {meetingSelect?.canceled_at
                    ? ''
                    : (userFiltered?.profile === 'GS1' ||
                        user?.profile === 'UN1') && (
                        <Button
                          variant="contained"
                          onClick={() => setOpenDrawerEditMembers(true)}
                          sx={{
                            width: '204px',
                            height: '40px',
                            padding: '6px 16px 6px 12px',
                          }}
                        >
                          Editar participantes
                        </Button>
                      )}
                </React.Fragment>
                <SwipeableDrawer
                  anchor="right"
                  onClose={() => setOpenDrawerEditMembers(false)}
                  onOpen={() => setOpenDrawerEditMembers(true)}
                  open={openDrawerEditMembers}
                >
                  {drawerEditMembros()}
                </SwipeableDrawer>
              </Box>
              <Div sx={{ marginTop: '20px', display: 'flex' }}>
                <BoxText
                  className="text-members"
                  display="flex"
                  flexDirection="row"
                  gap="20px"
                  alignItems="center"
                >
                  Organizadores:
                </BoxText>
                <AvatarGroup max={15} sx={{ marginLeft: '10px' }}>
                  {meetingSelect?.guests?.map(
                    u =>
                      u.profile === 'GS1' && (
                        <Tooltip title={u.name}>
                          {u?.avatar_url ? (
                            <Avatar sx={{ width: '40px' }}>
                              <img
                                src={u?.avatar_url}
                                alt="Foto de perfil"
                                style={{ width: '100%' }}
                              />
                            </Avatar>
                          ) : (
                            <Avatar
                              {...stringAvatar(u.name!)}
                              sx={{ width: '40px' }}
                            />
                          )}
                        </Tooltip>
                      ),
                  )}
                </AvatarGroup>
              </Div>
              <Div
                sx={{
                  marginTop: '20px',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '10px',
                }}
              >
                <BoxText
                  className="text-members"
                  display="flex"
                  flexDirection="row"
                  gap="20px"
                  alignItems="center"
                >
                  Membros:
                </BoxText>

                {listMeetingMembers.length > 0 ? (
                  <AvatarGroup max={15}>
                    {meetingSelect?.guests?.map(
                      u =>
                        u.profile === 'GS2' && (
                          <Tooltip title={u.name}>
                            {u?.avatar_url ? (
                              <Avatar sx={{ width: '40px' }}>
                                <img
                                  src={u?.avatar_url}
                                  alt="Foto de perfil"
                                  style={{ width: '100%' }}
                                />
                              </Avatar>
                            ) : (
                              <Avatar
                                {...stringAvatar(u.name!)}
                                sx={{ width: '40px' }}
                              />
                            )}
                          </Tooltip>
                        ),
                    )}
                  </AvatarGroup>
                ) : (
                  <Typography>
                    Nenhum membro foi adicionado à reunião.
                  </Typography>
                )}
              </Div>
            </Box>
          </SectionMeeting>
          <SectionMeeting>
            <Agenda
              filesToVerify={filesToVerify}
              maxMeetingDuration={meetingSelect.duration}
              meetingId={params?.id as string}
              listagemTemas={listagemTemas}
              setListagemTemas={setListagemTemas}
              listaUsuarios={listaUsuariosTheme}
              listaUsuariosAutocomplete={listagemRepresentantePauta}
              meetingSelect={meetingSelect}
              themesFinish={themesFinish}
            />
          </SectionMeeting>
          {meetingSelect?.canceled_at
            ? ''
            : meetingFinish && (
                <SectionMeeting>
                  <MeetingMinutes
                    setActiveStep={setActiveStep}
                    setThemesFinish={setThemesFinish}
                    setMeetingFinish={setMeetingFinish}
                    meetingFinish={meetingFinish}
                    meetingGuests={listaConvidados}
                    meetingSelect={meetingSelect}
                  />
                </SectionMeeting>
              )}

          {/* <SectionMeeting>
          <Box display="flex" flexDirection="column" width="100%">
            <TitleNotes>Anotações da Reunião</TitleNotes>
            <ListagemNotas
              listagemNotas={minhasNotas}
              setNoteToEdit={setNoteToEdit}
            />
          </Box>
        </SectionMeeting> */}
        </>
      )}
      {loadingSendInvite && (
        <LoadingBackdrop
          text="Enviando invite para participantes"
          component=""
          loading={loadingSendInvite}
        />
      )}
    </Container>
  );
};
